var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAttachedFileLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  opacity: 0.7
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.33333 0.666992H10.2761L14 4.39085V14.0003C14 14.7367 13.403 15.3337 12.6667 15.3337H3.33333C2.59695 15.3337 2 14.7367 2 14.0003V2.00033C2 1.26395 2.59695 0.666992 3.33333 0.666992ZM8.66667 2.00033H3.33333V14.0003H12.6667V6.00033H10C9.26362 6.00033 8.66667 5.40337 8.66667 4.66699V2.00033ZM10 2.27647V4.66699H12.3905L10 2.27647Z",
  fill: "#636766"
}))));
export { SvgAttachedFileLogo as ReactComponent };
export default __webpack_public_path__ + "41e99dee68ceecd682400bd24f287e33.svg";